import { MapService } from './../../utils/map.service';
import { DataManagementService } from './../../providers/data-management.service';
import { PointInterest } from './../../objects/data-management';
import { Stop } from './../../objects/real-time';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController,LoadingController,ViewController ,Events} from 'ionic-angular';
import {DatePipe} from '@angular/common';
import * as L from 'leaflet';
import {Poi} from '../poi/poi'
import { HistoricalForm } from '../historical-form/historical-form';

 @Component({
  selector: 'page-stop-list',
  templateUrl: 'stop-list.html',
})
export class StopList {
    //stops:any;
    stops:any[]  = [];;
    StopArray = [];
    stop : any ;
    nbrStop : number ;

  constructor(public navCtrl: NavController,
    private datamanagementService : DataManagementService,
    private mapService:MapService,
     public navParams: NavParams, 
     public viewCtrl: ViewController,
     private modalCtrl:ModalController,
     public events: Events) {
    //this.stops = navParams.get('stops');
    this.events.subscribe('listPathStop', (stop) => {
     // console.log(path);
  this.stops = stop;
  this.nbrStop = stop.length;
});
    this.callPathlist();
    console.log(this.stops);


      events.subscribe('stop', () => {
    this.publishStop();
});
  }

  callPathlist(){
this.events.publish("StopList");
}


seeOnMap(stop){
  this.stop = stop;
 this.events.publish("changeToMapStop",true);
     // this.navCtrl.setRoot(LeafletmapPage,{path: path});
}

publishStop(){
  this.events.publish("selectedStop",this.stop);
}







  //Dessiner stop
  drawStop(stop: any){
    this.viewCtrl.dismiss(stop);
  }
  //fermer modal
  closeModal(){
    this.viewCtrl.dismiss(1);
  }
  
  returnModal(){
    this.viewCtrl.dismiss(null);
  }

  //ouvrir modal poi 
  openPoiModal(stop:any){
    this.viewCtrl.dismiss(null);
    let pointInterest= new PointInterest();
    pointInterest.address=stop.geocodingDetails;
    pointInterest.coordinate.lat=stop.stopLatitude;
    pointInterest.coordinate.lng=stop.stopLongitude;
    let PoiModal = this.modalCtrl.create(Poi,{pointInterest});
    PoiModal.present();
    PoiModal.onDidDismiss(form => {
        if (pointInterest.type == "MARKER") {
          let circle = L.circle(pointInterest.coordinate, {
              color: 'red',
              fillColor: '#f03',
              fillOpacity: 0.1,
              radius: pointInterest.ray
          });
          this.mapService.addCircle(circle);
          this.mapService.map.setView({ lat: stop.stopLatitude, lng: stop.stopLongitude }, 15);
          setTimeout(()=> {
              this.mapService.removeCirclesFromMap();
          }, 3000);
        }
        
        this.drawStop(stop);  
     
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/stop-list/stop-list.ts